import React, {useState, useContext, useEffect} from "react";
import ListItem from "@common/ListItem";
import {UserContext} from "@context/UserContext";
import {TemplateContext} from "@common/context/TemplateContext";
import {ContentContext} from "@context/ContentContext";
import {BrandContext} from "@context/BrandContext";
import {ShortcutContext} from "@common/context/ShortcutContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import ListGroup from "@common/ListGroup";
import axios from "@common/axios";
import CircularLoader from "@common/CircularLoader";
import {NavigationContext} from "@common/context/NavigationContext";

const TrialNavigation = props => {
    const {grouping = true, tabIndex = 0} = props;
    const {user, setUser} = useContext(UserContext);
    const [isLoading, setLoading] = useState(true);
    const {singlePage} = useContext(TemplateContext);
    const brandConfig = useContext(BrandContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const [openStudentTrails, setOpenStudentTrails] = useState([]);
    let otherListGroupOptions  = {}
    if (props.indicatorPlacement) otherListGroupOptions.indicatorPlacement = props.indicatorPlacement;
    const { setNavVisible } = useContext(NavigationContext);

    const loadOpenStudentTrails = () => {
        axios.get('/web/ui/trail/openStudentTrails', {params: {pageNumber: 1}})
            .then(response => {
                setOpenStudentTrails(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(user !== undefined && user.student) {
            loadOpenStudentTrails();
        } else {
            setLoading(false);
        }
    }, []);

    if(isLoading) {
        return <CircularLoader pageCentered={false}/>
    }

    const handleClick = () => {
        const shortcutUrl = '/web/ui/view/trail/studentTrails';
        loadShortcutByUrl(shortcutUrl);
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    }

    if (grouping !== true) {
        if (openStudentTrails === undefined || openStudentTrails.length == 0) {
            return <ListItem isDisclosureItem={true} disabled={true}>You have no active {brandConfig.tasksName}</ListItem>
        } else {
            return (
                <>
                    {openStudentTrails.map((studentTrail, index) => {
                        return <ListItem isDisclosureItem={true} key={studentTrail.pathwayAssignmentId} onClick={handleClick}>
                            {studentTrail.pathwayAssignmentName}
                        </ListItem>
                    })}
                </>
            )
        }
    }
    if (openStudentTrails === undefined) {
        return null;
    }

    return (
        <ListGroup id={'trails-notifications-control'} isDisclosureItem={true} title={brandConfig.useDevelopmentNavigation ? brandConfig.tasksName : 'My latest ' + brandConfig.tasksName} itemCount={openStudentTrails.length} disabled={openStudentTrails.length == 0} startOpen={openStudentTrails.length > 0} {...otherListGroupOptions}>
            {openStudentTrails.map((studentTrail, index) => {
                return <ListItem isDisclosureItem={true} className={'ch-link'} key={studentTrail.pathwayAssignmentId} onClick={handleClick}>
                    {studentTrail.pathwayAssignmentName}
                </ListItem>
            })}
        </ListGroup>
    );
}

export default TrialNavigation;